/**
 * Header JS
 *
 * @since   1.0.0
 * @package premier
 */
(function($) {
    // Hook for when elementor front end is loaded
    $(window).on('elementor/frontend/init', function() {
        //hook name is 'frontend/element_ready/{widget-name}.{skin}
        //$scope is a jquery wrapped parent element
        elementorFrontend.hooks.addAction('frontend/element_ready/header.default', function($scope) {

            // Variables
            var $body = document.querySelector('body');
            var $header = document.querySelector('header[role="navigation"]');
            var topOfNav = $header.getBoundingClientRect().height;
            var $hamburger = document.querySelector('#menu-toggle');
            var $mobileNav = document.querySelector('#mobile-navigation');
            var $mobileMenuItemsWithChildren = $mobileNav.querySelectorAll('.menu-item-has-children');
            var $desktopMenuItemsWithChildren = document.querySelectorAll('.bottom-navigation .menu-item-has-children');
            var $logo = document.querySelector('.site-logo');
            var lastScrollTop = 0;

            function fixNav() {
                // stop if menu is open or admin bar is showing
                if ($hamburger.getAttribute('menu-status') === 'open' || $body.classList.contains('admin-bar') || (window.innerWidth < 1100)) {
                    return;
                }
                var st = window.pageYOffset || window.scrollTop;
                if (window.scrollY >= (topOfNav + 481) && (window.innerWidth >= 1440)) {
                    TweenMax.to($logo, 1, {
                        y: -19,
                        force3D: true,
                        ease: Expo.easeOut
                    });
                } else {
                    TweenMax.to($logo, 1, {
                        y: 0,
                        force3D: true,
                        ease: Expo.easeOut
                    });
                }
                if (window.scrollY >= topOfNav && st < lastScrollTop) {
                    TweenMax.to($header, 0.25, {
                        yPercent: 0,
                        ease: Expo.easeOut
                    });
                } else if (window.scrollY >= topOfNav && st >= lastScrollTop && st >= (topOfNav + 481)) {
                    TweenMax.to($header, 1, {
                        yPercent: -100,
                        ease: Expo.easeOut
                    });
                }
                lastScrollTop = st;
            }

            var toggleMenu = function(e) {
                var menuStatus = this.getAttribute('menu-status');
                var hamburger = this.firstElementChild;
                var barTop = hamburger.firstElementChild;
                var barMiddle = barTop.nextElementSibling;
                var barBottom = hamburger.lastElementChild;
                if (menuStatus === 'closed') {
                    this.setAttribute('menu-status', 'open');
                    bodyScrollLock.disableBodyScroll($mobileNav);
                    $mobileNav.classList.add('open');

                    var openHamburgerTl = new TimelineMax();
                    openHamburgerTl
                        .to(hamburger.children, 0.25, {
                            width: 0,
                            ease: Expo.easeOut
                        }, 'open')
                        .to(hamburger.children, 0.25, {
                            top: '50%',
                            ease: Expo.easeOut
                        }, 'open')
                        .to(this, 1, {
                            background: '#b51717',
                            borderLeft: '0',
                            ease: Expo.easeOut
                        }, 'open')
                        .fromTo($mobileNav, 1, {
                            xPercent: -100,
                            autoAlpha: 0
                        }, {
                            xPercent: 0,
                            autoAlpha: 1,
                            force3D: true,
                            ease: Expo.easeOut
                        }, 'open')
                        .to(barTop, 0.25, {
                            borderRadius: '3px',
                            top: '50%',
                            width: '100%',
                            force3D: true,
                            ease: Expo.easeOut
                        }, 'open')
                        .to(barBottom, 0.25, {
                            width: '100%',
                            borderRadius: '3px',
                            top: '50%',
                            force3D: true,
                            ease: Expo.easeOut
                        }, 'open')
                        .to(barTop, 0.25, {
                            backgroundColor: '#fff',
                            rotation: 45,
                            ease: Expo.easeInOut
                        }, 'open+=0.25')
                        .to(barBottom, 0.25, {
                            backgroundColor: '#fff',
                            rotation: -45,
                            ease: Expo.easeInOut
                        }, 'open+=0.25');

                } else {
                    this.setAttribute('menu-status', 'closed');
                    bodyScrollLock.enableBodyScroll($mobileNav);
                    $mobileNav.classList.remove('open');

                    var closeHamburgerTl = new TimelineMax();
                    closeHamburgerTl
                        .to(this, 1, {
                            background: 'transparent',
                            borderLeft: '2px solid #393837',
                            ease: Expo.easeOut
                        }, 'close')
                        .to($mobileNav, 1, {
                            xPercent: -100,
                            autoAlpha: 0,
                            ease: Expo.easeOut
                        }, 'close')
                        .to(barTop, 0.25, {
                            backgroundColor: '#890d0e',
                            borderRadius: '0',
                            width: '100%',
                            height: 4,
                            top: 0,
                            rotation: 0,
                            transformOrigin: 'center',
                            ease: Expo.easeOut
                        }, 'close')
                        .to(barMiddle, 0.25, {
                            width: '100%',
                            ease: Expo.easeOut
                        }, 'close')
                        .to(barBottom, 0.25, {
                            backgroundColor: '#890d0e',
                            borderRadius: '0',
                            width: '100%',
                            height: 4,
                            top: 'unset',
                            bottom: 0,
                            rotation: 0,
                            transformOrigin: 'center',
                            ease: Expo.easeOut
                        }, 'close');

                }

            };

            var toggleSubMenusMobile = function(e) {
                var submenu = this.previousElementSibling;
                var parentLi = this.parentElement;

                if (submenu.classList.contains('open')) {
                    submenu.classList.remove('open');
                    TweenMax.to(this, 0.25, {
                        rotation: 0,
                        ease: Expo.easeOut
                    });
                    TweenMax.to(parentLi, 0.25, {
                        marginBottom: 0,
                        ease: Expo.easeOut
                    });
                } else {
                    submenu.classList.add('open');
                    var subMenuHeight = submenu.getBoundingClientRect().height;
                    var parentLiHeight = parentLi.getBoundingClientRect().height;
                    TweenMax.to(this, 0.25, {
                        rotation: 180,
                        ease: Expo.easeOut
                    });
                    TweenMax.to(parentLi, 0.25, {
                        marginBottom: subMenuHeight,
                        ease: Expo.easeOut
                    });
                }
            };

            var subMenuEnterDesktop = function(e) {
                var activeLi = this;
                var activeSubmenu = this.querySelector('.sub-menu');
                var caret = this.querySelector('i');
                activeLi.classList.add('hovered');
                TweenMax.to(caret, 0.5, {
                    rotationX: 180,
                    ease: Expo.easeOut
                });
                TweenMax.to(activeSubmenu, 0.5, {
                    top: '100%',
                    autoAlpha: 1,
                    ease: Expo.easeOut
                });
            };

            var subMenuLeaveDesktop = function(e) {
                var activeLi = this;
                var activeSubmenu = this.querySelector('.sub-menu');
                var caret = this.querySelector('i');
                activeLi.classList.remove('hovered');
                TweenMax.to(caret, 0.5, {
                    rotationX: 0,
                    ease: Back.easeOut.config(1.7)
                });
                TweenMax.to(activeSubmenu, 0.5, {
                    top: 0,
                    autoAlpha: 0,
                    ease: Expo.easeOut
                });
            };

            // main mobile nav toggle
            $hamburger.addEventListener('click', toggleMenu);

            // mobile nav toggle sub nav items
            for (var i = 0; i < $mobileMenuItemsWithChildren.length; i++) {
                $mobileMenuItemsWithChildren[i].insertAdjacentHTML('beforeend', '<i class="fas fa-caret-down toggle-submenu"></i>');
                var mobileSubMenuToggle = document.querySelectorAll('.toggle-submenu');
                for (var j = 0; j < mobileSubMenuToggle.length; j++) {
                    mobileSubMenuToggle[j].addEventListener('click', toggleSubMenusMobile);
                }
            }

            for (var k = 0; k < $desktopMenuItemsWithChildren.length; k++) {
                $desktopMenuItemsWithChildren[k].insertAdjacentHTML('beforeend', '<i class="fas fa-caret-down toggle-submenu"></i>');
                $desktopMenuItemsWithChildren[k].addEventListener('mouseenter', subMenuEnterDesktop);
                $desktopMenuItemsWithChildren[k].addEventListener('mouseleave', subMenuLeaveDesktop);
            }

			// sticky nav
            if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
                return;
            } else {
                window.addEventListener('scroll', fixNav);
            }

        });
    });

})(jQuery);
